export function redirectWithQuery(to, baseUrl, targetPath, { replace = true } = {}) {
    const query = to.fullPath.split("?")[1]
    const url = new URL(targetPath, baseUrl)

    if (query) url.search = `?${query}`

    replace
        ? window.location.replace(url)
        : window.location.href = url
}